var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire6A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M4 0h2M3 1h1m1 0h1m3 0h1M3 2h1m1 0h1m3 0h2M2 3h1m3 0h1m1 0h1m1 0h1M1 4h1m4 0h1m1 0h1m1 0h1M1 5h1m5 0h2m1 0h1M1 6h1m8 0h1M1 7h1m8 0h1M1 8h1m8 0h1M2 9h1m3 0h1m2 0h2m-8 1h3m1 0h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M4 1h1M4 2h1M3 3h1m1 0h1m3 0h1M2 4h2m5 0h1M2 5h1M2 8h1m6 0h1M3 9h3m1 0h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M4 3h1m0 1h1M3 5h1m2 0h1m2 0h1M2 6h1m4 0h1m1 0h1M2 7h1m6 0h1M3 8h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8300",
    d: "M4 4h1m0 1h1M3 6h1m2 0h1m1 0h1M3 7h1m3 0h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffae00",
    d: "M4 5h1M4 6h2M4 7h3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire6A);
export default __webpack_public_path__ + "static/media/fire6a.d8e9fe8203cd1c88b754303ef36f30ef.svg";
export { ForwardRef as ReactComponent };